
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/video/[canais]/[videos]",
      function () {
        return require("private-next-pages/video/[canais]/[videos].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/video/[canais]/[videos]"])
      });
    }
  